export const isLinkedInApp = (s: string) => s.includes(`[LinkedInApp]`)

export const isInAppWebView = (s: string) => isLinkedInApp(s)

export const isSafari = (s: string) => /^((?!chrome|android).)*safari/i.test(s)
